import { DateTime } from 'luxon'

import type { DayPeriod, DateInFullConfig } from './types'

const convertArrayToDateTime = (dateArray: Array<number>): DateTime => {
  const [year, month, day, hour, minute, second] = dateArray

  const dateTime = DateTime.local(year, month, day, hour, minute, second)

  return dateTime
}

const getDayPeriod = (date: DateTime | Array<number>): DayPeriod => {
  const dateTime = date instanceof Array ? convertArrayToDateTime(date) : date

  if (dateTime.hour < 12) {
    return 'manhã'
  }

  if (dateTime.hour < 19) {
    return 'tarde'
  }

  return 'noite'
}

const getDateInFull = (
  date: DateTime | Array<number>,
  { reversed = false, year }: DateInFullConfig,
): string => {
  const dateTime = date instanceof Array ? convertArrayToDateTime(date) : date

  const dateInFullConfig: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'long',
    weekday: 'long',
    ...(year && { year }), // se for passado o ano, adiciona o ano
  }

  const dateInFull = dateTime.toLocaleString(dateInFullConfig)

  if (reversed) {
    return dateInFull.split(', ').reverse().join(', ')
  }

  return dateInFull
}

const getTimeInHourAndMinute = (date: DateTime | Array<number>): string => {
  const dateTime = date instanceof Array ? convertArrayToDateTime(date) : date

  const time = dateTime.toLocaleString({
    hour: '2-digit',
    minute: '2-digit',
  })

  return time
}

const convertStringIntoDateArray = (value: string): Array<number> => {
  const [date, time] = value.split(' ')
  const [day, month, year] = date.split('/')
  const [hour, minutes, seconds] = time.split(':')

  const orderedDateTime = [year, month, day, hour, minutes, seconds]
  const transformIntoZeroUndefinedValues = orderedDateTime?.map(i => i || '0')
  const transformItemsIntoNumbers = transformIntoZeroUndefinedValues?.map(i =>
    parseInt(i),
  )
  return transformItemsIntoNumbers
}

const getUnixTimestamp = (date: Date): number => {
  return Math.floor(date?.getTime() / 1000)
}

const formatToBRDate = (date): string => {
  if (typeof date === 'object') {
    const dt = DateTime.fromJSDate(date)
    return dt.toFormat('dd/MM/yyyy')
  } else {
    return date
  }
}

export {
  convertArrayToDateTime,
  convertStringIntoDateArray,
  getDayPeriod,
  getDateInFull,
  getTimeInHourAndMinute,
  getUnixTimestamp,
  formatToBRDate,
}
